export const cmps = {
    CODIGO: 'codigo',
    DENOMINACION: 'denominacion',
    ES_SERVICIO: 'esServicio',
    ESTADO: 'estado'
}